import { GetSmsTemplateMeta, GetSmsTemplatePayload } from 'types/store/GetSmsTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { getSmsTemplateActions } from '../actions';

export default createAsyncReducer<GetSmsTemplateMeta, GetSmsTemplatePayload>(getSmsTemplateActions);
